<!-- Trailer Modal -->
<div class="trailer-modal-backdrop" *ngIf="showPlayer" (click)="closeTrailer()">
  <div class="trailer-modal-container" (click)="$event.stopPropagation()">
    <button class="trailer-close-btn" (click)="closeTrailer()" aria-label="Close trailer">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <line x1="18" y1="6" x2="6" y2="18"></line>
        <line x1="6" y1="6" x2="18" y2="18"></line>
      </svg>
    </button>
    <div class="trailer-content" id="season-trailer-player"></div>
  </div>
</div>

<div class="season-page-wrapper">
  <!-- ══════════════════════════════════════════════════════════
       Main Hero Section (Matching tv-details & movie-details)
       ══════════════════════════════════════════════════════════ -->
  <section class="movie-details-container">
    <div class="backdrop-image-container" id="backdropContainer" [ngStyle]="{'background-color': middleColor}">
      <img *ngIf="backdropImageSrc" #backdropImage class="movie-backdrop-image" [class.loaded]="backdropLoaded"
        id="backdropImage" [src]="backdropImageSrc" (load)="onImageLoad(backdropImage)" alt="Season backdrop"
        crossorigin="anonymous">
    </div>

    <div class="movie-details">
      <!-- Poster with season badge -->
      <div class="poster-wrapper">
        <img class="movie-poster"
          [src]="'https://image.tmdb.org/t/p/original/' + (seasonDetails?.poster_path || tvDetails?.poster_path)"
          [alt]="seasonDetails?.name || 'Season Poster'" (error)="onImageError($event)">
        <span class="poster-season-pill" *ngIf="seasonNumber">
          Season {{ seasonNumber }}
        </span>
      </div>

      <!-- Info Column -->
      <div class="movie-info">
        <!-- Breadcrumb / Back Link -->
        <div class="season-breadcrumb">
          <button class="breadcrumb-back-btn" (click)="backToShow()" title="Back to {{ showName || 'TV Show' }}">
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"
              stroke-linecap="round" stroke-linejoin="round">
              <polyline points="15 18 9 12 15 6" />
            </svg>
            <span>Back to {{ showName || 'Show' }}</span>
          </button>
          <span class="breadcrumb-sep">/</span>
          <span class="breadcrumb-current">{{ seasonDetails?.name || 'Season ' + seasonNumber }}</span>
        </div>

        <!-- Title -->
        <h1 class="movie-title">
          <span class="movie-title-show" *ngIf="showName">{{ showName }} &bull; </span>
          <span class="movie-title-season">{{ seasonDetails?.name || 'Season ' + seasonNumber }}</span>
        </h1>

        <!-- Metadata row -->
        <div class="movie-metadata">
          <!-- Ratings Circle -->
          <div class="ratings-container" *ngIf="seasonDetails?.vote_average || tvDetails?.vote_average">
            <div class="ratings-circle-container">
              <div class="ratings-circle">
                <span class="ratings-text">{{ filterRating(seasonDetails?.vote_average || tvDetails?.vote_average)
                  }}%</span>
              </div>
            </div>
          </div>

          <!-- Air Year -->
          <span class="movie-year" *ngIf="seasonDetails?.air_date">
            {{ seasonDetails.air_date | date: 'yyyy' }}
          </span>

          <!-- Episode Count -->
          <span class="movie-ep-count" *ngIf="seasonDetails?.episodes?.length || seasonDetails?.episode_count">
            {{ seasonDetails?.episodes?.length || seasonDetails?.episode_count }} Episodes
          </span>

          <!-- Genres -->
          <span class="movie-genre" *ngIf="tvDetails?.genres?.length">
            <ng-container *ngFor="let genre of tvDetails.genres; let last = last">
              {{ genre?.name }}<span *ngIf="!last">, </span>
            </ng-container>
          </span>
        </div>

        <!-- Overview -->
        <p class="movie-overview" [attr.title]="seasonDetails?.overview || tvDetails?.overview">
          {{ seasonDetails?.overview || tvDetails?.overview || 'No overview available for this season.' }}
        </p>

        <!-- Actions -->
        <div class="hero-actions">
          <button class="movie-trailer" (click)="playTrailer()">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
              <polygon points="5 3 19 12 5 21 5 3" />
            </svg>
            <span>Play Trailer</span>
          </button>

          <!-- Season Switcher in Hero -->
          <div class="hero-season-nav" *ngIf="allSeasons && allSeasons.length > 1">
            <button class="hero-nav-arrow" (click)="previousSeason()" [disabled]="isFirstSeason"
              title="Previous Season">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                <polyline points="15 18 9 12 15 6" />
              </svg>
            </button>

            <div class="hero-select-wrap">
              <select class="hero-season-dropdown" [value]="seasonNumber" (change)="onSeasonSelect($event)">
                <option *ngFor="let s of allSeasons" [value]="s.season_number">
                  {{ s.name || 'Season ' + s.season_number }} ({{ s.episode_count }} ep)
                </option>
              </select>
              <svg class="dropdown-chevron" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                stroke-width="2.5">
                <polyline points="6 9 12 15 18 9" />
              </svg>
            </div>

            <button class="hero-nav-arrow" (click)="nextSeason()" [disabled]="isLastSeason" title="Next Season">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                <polyline points="9 18 15 12 9 6" />
              </svg>
            </button>
          </div>

          <button class="hero-share-btn" (click)="shareSeason()" title="Share Season">
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <circle cx="18" cy="5" r="3"></circle>
              <circle cx="6" cy="12" r="3"></circle>
              <circle cx="18" cy="19" r="3"></circle>
              <line x1="8.59" y1="13.51" x2="15.42" y2="17.49"></line>
              <line x1="15.41" y1="6.51" x2="8.59" y2="10.49"></line>
            </svg>
            <span>Share</span>
          </button>
        </div>
      </div>
    </div>
  </section>

  <!-- ══════════════════════════════════════════════════════════
       Tabs Switcher (Matching Home Page Trailer Section Style)
       ══════════════════════════════════════════════════════════ -->
  <section class="season-tabs-bar-shell">
    <div class="tabs-header-content">
      <!-- Desktop Wide Pill Switcher -->
      <div class="adaptive-toggle switch-desktop cinema-toggle">
        <div class="adaptive-toggle-tabs adaptive-toggle-tabs-wide trending-switcher-container">
          <button type="button" class="adaptive-toggle-btn" *ngFor="let tab of tabs; let i = index"
            [class.active]="activeTab === i" (click)="switchTab(i)">
            {{ getTabLabel(i) }}
          </button>
        </div>
      </div>

      <!-- Tablet / Mobile Dropdown Switcher -->
      <div class="adaptive-toggle switch-tablet cinema-toggle">
        <button type="button" class="adaptive-toggle-trigger" [class.open]="isDropDown" (click)="toggleDropdown()">
          <span class="adaptive-trigger-label">
            {{ getTabLabel(activeTab) }}
          </span>
          <span class="adaptive-caret">
            <svg viewBox="0 0 10 6" fill="none">
              <path d="M1 1l4 4 4-4" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </span>
        </button>

        <div class="adaptive-toggle-menu" *ngIf="isDropDown">
          <button type="button" class="adaptive-toggle-item" *ngFor="let tab of tabs; let i = index"
            [class.active]="activeTab === i" (click)="selectTab(i)">
            <span>{{ getTabLabel(i) }}</span>
            <span class="adaptive-check" *ngIf="activeTab === i">✓</span>
          </button>
        </div>
      </div>
    </div>
  </section>

  <!-- ══════════════════════════════════════════════════════════
       Main 2-Column Content Section (Matching tv.html flex-parent)
       ══════════════════════════════════════════════════════════ -->
  <div class="flex-parent">
    <!-- Left Column (70%): Episodes / Cast / Videos / Details -->
    <main class="tv-left">
      <!-- ── TAB 0: EPISODES ── -->
      <section class="tab-panel" *ngIf="activeTab === 0">
        <div class="panel-header">
          <div class="panel-header-left">
            <div>
              <h2 class="cinema-section-title">Episodes Guide</h2>
              <span class="panel-subtitle">{{ seasonDetails?.name || 'Season ' + seasonNumber }} &bull; {{
                seasonDetails?.episodes?.length || 0 }} Episodes</span>
            </div>
          </div>
        </div>

        <!-- Episodes Cards List -->
        <div class="episodes-list" *ngIf="seasonDetails?.episodes?.length">
          <article class="episode-card" *ngFor="let episode of seasonDetails.episodes"
            (click)="navigateToEpisode(episode)">
            <!-- Thumbnail Box -->
            <div class="episode-thumb-wrap">
              <img class="episode-img"
                [src]="episode.still_path ? ('https://image.tmdb.org/t/p/w500' + episode.still_path) : 'assets/images/placeholder.png'"
                [alt]="episode.name" (error)="onImageError($event)">
              <div class="episode-play-overlay">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                  <polygon points="5 3 19 12 5 21 5 3" />
                </svg>
              </div>
              <span class="episode-num-badge">EP {{ episode.episode_number }}</span>
              <span class="episode-runtime-badge" *ngIf="episode.runtime">{{ episode.runtime }} min</span>
            </div>

            <!-- Content Box -->
            <div class="episode-content">
              <div class="episode-top-row">
                <span class="episode-air-date" *ngIf="episode.air_date">
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
                    <line x1="16" y1="2" x2="16" y2="6" />
                    <line x1="8" y1="2" x2="8" y2="6" />
                    <line x1="3" y1="10" x2="21" y2="10" />
                  </svg>
                  {{ episode.air_date | date: 'MMM d, yyyy' }}
                </span>
                <span class="episode-rating-pill" *ngIf="episode.vote_average">
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor">
                    <path
                      d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
                  </svg>
                  {{ episode.vote_average | number:'1.1-1' }}
                </span>
              </div>

              <h3 class="episode-name">
                <span class="ep-prefix">{{ episode.episode_number }}.</span> {{ episode.name || 'Episode ' +
                episode.episode_number }}
              </h3>

              <p class="episode-overview" *ngIf="episode.overview">
                {{ episode.overview }}
              </p>

              <div class="episode-footer">
                <span class="episode-director" *ngIf="getEpisodeDirector(episode)">
                  <strong>Director:</strong> {{ getEpisodeDirector(episode) }}
                </span>
                <button class="episode-action-btn" (click)="navigateToEpisode(episode); $event.stopPropagation()">
                  <span>Episode Details</span>
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                    <polyline points="9 18 15 12 9 6" />
                  </svg>
                </button>
              </div>
            </div>
          </article>
        </div>

        <!-- Empty State -->
        <div class="empty-state-box" *ngIf="!seasonDetails?.episodes?.length">
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#94a3b8" stroke-width="1.5">
            <rect x="2" y="2" width="20" height="20" rx="2.18" ry="2.18" />
            <line x1="7" y1="2" x2="7" y2="22" />
            <line x1="17" y1="2" x2="17" y2="22" />
            <line x1="2" y1="12" x2="22" y2="12" />
          </svg>
          <h3>No Episodes Listed</h3>
          <p>Episode details will appear here as soon as they become available.</p>
        </div>
      </section>

      <!-- ── TAB 1: CAST & CREW (With movie-card actor design matching project) ── -->
      <section class="tab-panel" *ngIf="activeTab === 1">
        <div class="panel-header">
          <div class="panel-header-left">
            <div>
              <h2 class="cinema-section-title">Cast & Crew</h2>
              <span class="panel-subtitle">Featuring talent from {{ showName }}</span>
            </div>
          </div>
          <!-- Scroll Buttons -->
          <div class="carousel-nav-arrows" *ngIf="castList.length > 3">
            <button class="carousel-arrow-btn" (click)="scrollCastLeft()" title="Scroll Left">
              <i class="fa-solid fa-arrow-left"></i>
            </button>
            <button class="carousel-arrow-btn" (click)="scrollCastRight()" title="Scroll Right">
              <i class="fa-solid fa-arrow-right"></i>
            </button>
          </div>
        </div>

        <div class="trending-wrapper" *ngIf="castList?.length">
          <div #castScrollContainer class="trending-movie-section actor-scroll-row">
            <div *ngFor="let credit of castList" class="trending-movie-container">
              <div class="movie-card">
                <a [routerLink]="['/person', credit?.id + '-' + formattedPersonName(credit?.name)]">
                  <img class="movie-image"
                    [src]="credit.profile_path ? ('https://image.tmdb.org/t/p/w500' + credit.profile_path) : 'assets/images/not_found_2_3.png'"
                    [alt]="credit?.name" (error)="onImageError($event)">
                </a>
                <div class="content my-2 mx-1">
                  <a [routerLink]="['/person', credit?.id + '-' + formattedPersonName(credit?.name)]"
                     class="movie-name">
                    {{ credit?.name }}
                  </a>
                  <p class="movie-date" *ngIf="credit?.character">
                    {{ credit?.character }}
                  </p>
                  <p class="movie-date" *ngIf="!credit?.character && credit?.job">
                    {{ credit?.job }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Empty state -->
        <div class="empty-state-box" *ngIf="!castList?.length">
          <p>No cast information available.</p>
        </div>
      </section>

      <!-- ── TAB 2: VIDEOS ── -->
      <section class="tab-panel" *ngIf="activeTab === 2">
        <div class="panel-header">
          <div class="panel-header-left">
            <div>
              <h2 class="cinema-section-title">Videos & Trailers</h2>
              <span class="panel-subtitle">Promotional clips, trailers, and teasers</span>
            </div>
          </div>
        </div>

        <div class="videos-grid" *ngIf="videoList?.length">
          <article class="video-card" *ngFor="let video of videoList" (click)="trailerId = video.key; playTrailer()">
            <div class="video-thumb-wrap">
              <img class="video-img" [src]="'https://img.youtube.com/vi/' + video.key + '/hqdefault.jpg'"
                [alt]="video.name">
              <div class="video-play-btn">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                  <polygon points="5 3 19 12 5 21 5 3" />
                </svg>
              </div>
              <span class="video-type-tag">{{ video.type }}</span>
            </div>
            <div class="video-info">
              <h4 class="video-title">{{ video.name }}</h4>
            </div>
          </article>
        </div>

        <!-- Empty state -->
        <div class="empty-state-box" *ngIf="!videoList?.length">
          <p>No videos available for this season.</p>
        </div>
      </section>

      <!-- ── TAB 3: DETAILS & FACTS ── -->
      <section class="tab-panel" *ngIf="activeTab === 3">
        <div class="panel-header">
          <div class="panel-header-left">
            <div>
              <h2 class="cinema-section-title">Season Details</h2>
              <span class="panel-subtitle">Comprehensive season information</span>
            </div>
          </div>
        </div>

        <div class="details-card">
          <div class="details-overview-block" *ngIf="seasonDetails?.overview">
            <h4 class="details-subhead">Season Synopsis</h4>
            <p class="details-text">{{ seasonDetails.overview }}</p>
          </div>

          <div class="details-grid-specs">
            <div class="spec-box">
              <span class="spec-label">Show</span>
              <span class="spec-val">{{ showName }}</span>
            </div>
            <div class="spec-box">
              <span class="spec-label">Season Name</span>
              <span class="spec-val">{{ seasonDetails?.name || 'Season ' + seasonNumber }}</span>
            </div>
            <div class="spec-box">
              <span class="spec-label">Season Number</span>
              <span class="spec-val">{{ seasonNumber }}</span>
            </div>
            <div class="spec-box">
              <span class="spec-label">Total Episodes</span>
              <span class="spec-val">{{ seasonDetails?.episodes?.length || seasonDetails?.episode_count || 0 }}</span>
            </div>
            <div class="spec-box" *ngIf="seasonDetails?.air_date">
              <span class="spec-label">Premiere Date</span>
              <span class="spec-val">{{ seasonDetails.air_date | date: 'MMMM d, yyyy' }}</span>
            </div>
            <div class="spec-box" *ngIf="seasonDetails?.vote_average">
              <span class="spec-label">Average Rating</span>
              <span class="spec-val">{{ seasonDetails.vote_average | number:'1.1-1' }} / 10</span>
            </div>
          </div>
        </div>
      </section>

      <!-- ── Bottom Season Switcher Bar ── -->
      <div class="season-bottom-nav">
        <button class="season-bottom-btn" (click)="previousSeason()" [disabled]="isFirstSeason">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
            <polyline points="15 18 9 12 15 6" />
          </svg>
          <div class="btn-text-group">
            <span class="btn-label">Previous Season</span>
            <span class="btn-sub" *ngIf="!isFirstSeason">Season {{ seasonNumber - 1 }}</span>
          </div>
        </button>

        <button class="season-bottom-btn next-btn" (click)="nextSeason()" [disabled]="isLastSeason">
          <div class="btn-text-group text-right">
            <span class="btn-label">Next Season</span>
            <span class="btn-sub" *ngIf="!isLastSeason">Season {{ seasonNumber + 1 }}</span>
          </div>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
            <polyline points="9 18 15 12 9 6" />
          </svg>
        </button>
      </div>
    </main>

    <!-- Right Column (30%): Season Facts Sidebar + Other Seasons Card -->
    <aside class="tv-right">
      <!-- ── Season Facts Card (Matching tv-facts layout) ── -->
      <div class="season-facts-panel">
        <div class="facts-header">
          <div class="facts-header-left">
            <div class="header-icon-box">
              <i class="fas fa-circle-info"></i>
            </div>
            <div>
              <h3 class="facts-title">Season Facts</h3>
              <span class="facts-subtitle">Quick Season Metrics</span>
            </div>
          </div>
        </div>

        <!-- Metrics Grid (4 Highlights) -->
        <div class="facts-metrics-grid">

          <!-- Rating -->
          <div class="metric-card rating-card" *ngIf="seasonDetails?.vote_average || tvDetails?.vote_average">
            <div class="metric-top">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="#f59e0b">
                <path
                  d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
              </svg>
              <span class="metric-label">Rating</span>
            </div>
            <div class="metric-value">
              <span class="rating-num">{{ (seasonDetails?.vote_average || tvDetails?.vote_average) | number:'1.1-1'
                }}</span>
              <span class="rating-denom">/10</span>
            </div>
          </div>

          <!-- Season # -->
          <div class="metric-card">
            <div class="metric-top">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#12b886" stroke-width="2">
                <rect x="2" y="2" width="20" height="20" rx="2.18" ry="2.18" />
                <line x1="7" y1="2" x2="7" y2="22" />
              </svg>
              <span class="metric-label">Season</span>
            </div>
            <span class="metric-value">#{{ seasonNumber }}</span>
          </div>

          <!-- Episodes Count -->
          <div class="metric-card">
            <div class="metric-top">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#12b886" stroke-width="2">
                <line x1="8" y1="6" x2="21" y2="6" />
                <line x1="8" y1="12" x2="21" y2="12" />
                <line x1="8" y1="18" x2="21" y2="18" />
                <line x1="3" y1="6" x2="3.01" y2="6" />
                <line x1="3" y1="12" x2="3.01" y2="12" />
                <line x1="3" y1="18" x2="3.01" y2="18" />
              </svg>
              <span class="metric-label">Episodes</span>
            </div>
            <span class="metric-value">{{ seasonDetails?.episodes?.length || seasonDetails?.episode_count || 0 }}</span>
          </div>
        </div>

        <!-- Detail rows -->
        <div class="facts-rows-list">
          <!-- Show Title -->
          <div class="fact-row" *ngIf="showName">
            <div class="fact-row-header">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <rect x="2" y="7" width="20" height="15" rx="2" ry="2" />
                <polyline points="17 2 12 7 7 2" />
              </svg>
              <span>Show</span>
            </div>
            <a class="fact-row-content show-link" (click)="backToShow()">{{ showName }}</a>
          </div>

          <!-- Air Date -->
          <div class="fact-row" *ngIf="seasonDetails?.air_date">
            <div class="fact-row-header">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
                <line x1="16" y1="2" x2="16" y2="6" />
                <line x1="8" y1="2" x2="8" y2="6" />
                <line x1="3" y1="10" x2="21" y2="10" />
              </svg>
              <span>Premiere Date</span>
            </div>
            <span class="fact-row-content">{{ seasonDetails.air_date | date:'MMMM d, yyyy' }}</span>
          </div>

          <!-- Networks -->
          <div class="fact-block" *ngIf="tvDetails?.networks?.length">
            <div class="fact-row-header">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <circle cx="12" cy="12" r="2" />
                <path
                  d="M16.24 7.76a6 6 0 0 1 0 8.49m-8.48-.01a6 6 0 0 1 0-8.49m11.31-2.82a10 10 0 0 1 0 14.14m-14.14 0a10 10 0 0 1 0-14.14" />
              </svg>
              <span>Network</span>
            </div>
            <div class="networks-container">
              <div class="network-badge" *ngFor="let net of tvDetails.networks">
                <img *ngIf="net.logo_path" [src]="'https://image.tmdb.org/t/p/w200' + net.logo_path" [alt]="net.name"
                  class="network-logo" (error)="onImageError($event)">
                <span class="network-name">{{ net.name }}</span>
              </div>
            </div>
          </div>

          <!-- Genres -->
          <div class="fact-block" *ngIf="tvDetails?.genres?.length">
            <div class="fact-row-header">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z" />
                <line x1="7" y1="7" x2="7.01" y2="7" />
              </svg>
              <span>Genres</span>
            </div>
            <div class="pills-container">
              <span class="info-pill" *ngFor="let genre of tvDetails.genres">
                {{ genre.name }}
              </span>
            </div>
          </div>

          <!-- Action Button: Back to Main Show -->
          <div class="sidebar-action-wrap">
            <button class="back-to-show-cta" (click)="backToShow()">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                <polyline points="15 18 9 12 15 6" />
              </svg>
              <span>Explore All {{ showName }} Seasons</span>
            </button>
          </div>
        </div>
      </div>

      <!-- ── All Seasons Card ── -->
      <div class="other-seasons-panel" *ngIf="allSeasons && allSeasons.length > 1">
        <div class="panel-box-header">
          <div class="header-icon-box small">
            <i class="fas fa-layer-group"></i>
          </div>
          <div>
            <h4 class="box-title">All Seasons</h4>
            <span class="box-subtitle">{{ allSeasons.length }} Seasons in Total</span>
          </div>
        </div>

        <div class="seasons-mini-list">
          <div class="season-mini-card" *ngFor="let s of allSeasons"
            [class.active-season]="s.season_number === seasonNumber" (click)="navigateToSeason(s.season_number)">
            <img class="season-mini-poster"
              [src]="'https://image.tmdb.org/t/p/w200' + (s.poster_path || tvDetails?.poster_path)" [alt]="s.name"
              (error)="onImageError($event)">
            <div class="season-mini-info">
              <div class="season-mini-title-row">
                <span class="season-mini-name">{{ s.name || 'Season ' + s.season_number }}</span>
                <span class="season-current-tag" *ngIf="s.season_number === seasonNumber">Current</span>
              </div>
              <div class="season-mini-meta">
                <span *ngIf="s.air_date">{{ s.air_date | date:'yyyy' }}</span>
                <span *ngIf="s.episode_count">&bull; {{ s.episode_count }} Episodes</span>
                <span *ngIf="s.vote_average">&bull; {{ s.vote_average | number:'1.1-1' }}★</span>
              </div>
            </div>
            <svg class="mini-arrow" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
              stroke-width="2.5">
              <polyline points="9 18 15 12 9 6" />
            </svg>
          </div>
        </div>
      </div>
    </aside>
  </div>
</div>